import { cn } from '@/utils/commonUtil'

import styles from './Splash.module.scss'

type Props = {
  align?: 'left' | 'right' | 'outsideLeft' | 'outsideRight'
  aspectRatio?: string
  backgroundImages?: string[]
  bgCover?: boolean
  breakpoint?: 'xsm' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl'
  contrastNone?: boolean
  flipX?: boolean
  isAboveFold?: boolean
  maskNone?: boolean
  objectPosition?: string
  subtle?: boolean
  variant?: 'featured'
}

export const Splash = ({
  align,
  aspectRatio,
  backgroundImages,
  bgCover,
  breakpoint,
  contrastNone,
  flipX,
  isAboveFold,
  maskNone,
  objectPosition,
  subtle,
  variant,
}: Props) => {
  const imagesStyle = {
    ...(aspectRatio && { '--aspect-ratio': aspectRatio }),
    ...(objectPosition && { '--object-position': objectPosition }),
  } as React.CSSProperties

  return (
    <div
      aria-hidden
      className={cn(styles.container, {
        align,
        bgCover,
        breakpoint,
        contrastNone,
        count: String(backgroundImages?.length || 0),
        flipX,
        maskNone,
        styles,
        subtle,
        variant,
      })}
    >
      {backgroundImages && (
        <div className={styles.images} style={imagesStyle}>
          {backgroundImages.map((i, key) => (
            <img
              alt=''
              className={styles.image}
              decoding='async'
              fetchPriority={isAboveFold ? 'high' : undefined}
              key={key}
              loading={isAboveFold ? 'eager' : 'lazy'}
              role='presentation'
              src={i}
            />
          ))}
        </div>
      )}
    </div>
  )
}
